import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { first, map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UniversalLoginGuard implements CanActivate {
  public isUniversalLogin: boolean;
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(
      first(),
      tap((isAuthenticated) => {
        if (isAuthenticated) {
          this.router.navigate(['/']);
        } else {
          this.authService.loginWithRedirect();
        }
      }),
      map(() => false)
    );
  }
}
